import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MESSAGE_TYPES, NAVIGATION_CHANNEL_NAME, TAB_ID_KEY } from '../constants/broadcastConstants';

type Payload = { type: string; url: string; senderId?: string };

export function useBroadcastNavigation() {
    const navigate = useNavigate();

    useEffect(() => {
        if (!('BroadcastChannel' in window)) return;

        const bc = new BroadcastChannel(NAVIGATION_CHANNEL_NAME);
        let myTabId = sessionStorage.getItem(TAB_ID_KEY);

        if (!myTabId) {
            myTabId = Math.random().toString(36).slice(2);
            sessionStorage.setItem(TAB_ID_KEY, myTabId);
        }

        bc.onmessage = (ev: MessageEvent) => {
            const data = ev.data as Payload | undefined;
            if (!data || data.type !== MESSAGE_TYPES.NAVIGATE_TO_URL || !data.url) return;
            if (data.senderId === myTabId) return; // ignore self

            // Always navigate / update URL
            try {
                const u = new URL(data.url, window.location.origin);
                const pathWithSearch = u.pathname + u.search;
                navigate(pathWithSearch, { replace: true });
            } catch {
                window.location.href = data.url;
            }

            bc.postMessage({
                type: MESSAGE_TYPES.CLAIM_WINDOW,
                url: data.url,
                senderId: myTabId,
            });
        };

        return () => bc.close();
    }, [navigate]);
}
